import docElement from './document';
import wnd from './window';

export default function scrollPosition(element) {
    var documentElement = docElement(element);
    var win = wnd(element);

    return {
        x: win.pageXOffset || documentElement.scrollLeft || 0,
        y: win.pageYOffset || documentElement.scrollTop || 0
    };
}



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/scroll-position.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/scroll-position.js
// module chunks = 3